// extracted by mini-css-extract-plugin
module.exports = {"cls1":"about-Main-module--cls1--T5VfJ","cls2":"about-Main-module--cls2--2qdH6 about-Main-module--cls1--T5VfJ"};